var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21925_34657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26599 3.55499C4.26584 3.621 4.2522 3.68626 4.22589 3.7468C4.19958 3.80733 4.16116 3.86184 4.11301 3.90698L0.894989 6.96399C0.794331 7.05762 0.661975 7.10968 0.524506 7.10968C0.387036 7.10968 0.25465 7.05762 0.153992 6.96399C0.106291 6.91902 0.0683046 6.86478 0.0423279 6.8046C0.0163511 6.74441 0.00292969 6.67954 0.00292969 6.61398C0.00292969 6.54843 0.0163511 6.48359 0.0423279 6.4234C0.0683046 6.36321 0.106291 6.30897 0.153992 6.26401L3.00198 3.55899L0.153992 0.854004C0.106291 0.809037 0.0683046 0.754798 0.0423279 0.694611C0.0163511 0.634423 0.00292969 0.569552 0.00292969 0.503998C0.00292969 0.438444 0.0163511 0.373572 0.0423279 0.313385C0.0683046 0.253198 0.106291 0.198958 0.153992 0.153992C0.25465 0.0603658 0.387036 0.0083313 0.524506 0.0083313C0.661975 0.0083313 0.794331 0.0603658 0.894989 0.153992L4.11301 3.211C4.1602 3.25521 4.19803 3.30841 4.2243 3.36749C4.25058 3.42658 4.26476 3.49034 4.26599 3.55499Z",
    fill: "#0158E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21925_34657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.266,
    height: 7.11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGroup);
export default __webpack_public_path__ + "static/media/createGroup.c0d477d89dbb75fc5a551196d49ff2d4.svg";
export { ForwardRef as ReactComponent };